// extracted by mini-css-extract-plugin
module.exports = {"startmenuRoot":"startmenuRoot--1a1a7"};